import { doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { adminUid, db } from "./firebase";

export const LEGACY_MIGRATION_ID = "legacy-notices-2026-v1";

export const LEGACY_NOTICES = [
  {
    id: "legacy-first-meeting",
    title: "समितिको प्रथम बैठक सम्पन्न",
    type: "सूचना",
    date: "०५ बैशाख २०८३",
    content:
      "नेपाली कांग्रेस कुश्मी-गाउँ काठमाडौं सम्पर्क समितिको प्रथम बैठक सफलतापूर्वक सम्पन्न भएको छ। बैठकमा समितिको कार्यदिशा, योजना र भविष्यका कार्यक्रमहरूबारे छलफल भयो।",
    important: true,
  },
  {
    id: "legacy-welcome-message",
    title: "स्वागत सन्देश",
    type: "सूचना",
    date: "०५ बैशाख २०८३",
    content:
      "नेपाली कांग्रेस कुश्मी-गाउँ काठमाडौं सम्पर्क समितिको आधिकारिक वेबसाइटमा सबैलाई हार्दिक स्वागत छ। यस मञ्चमार्फत हामी पार्टीका गतिविधि, सूचना र विज्ञप्तिहरू प्रकाशित गर्नेछौं।",
    important: false,
  },
  {
    id: "legacy-call-to-all",
    title: "संपूर्णलाई आह्वान",
    type: "आह्वान",
    date: "०५ बैशाख २०८३",
    content:
      "नेपाली कांग्रेस सम्बन्धी अदालतले दिएको फैसलाले पार्टीभित्रको धारलाई स्पष्टता दिँदै गगन थापा लगायतको नेतृत्वप्रति विश्वासको आधार थप मजबुत बनाएको छ। यस परिप्रेक्ष्यमा विशेष महाधिवेशनबाट निर्वाचित पार्टी सभापतिलाई पूर्ण रूपमा स्वीकार गर्नु आजको आवश्यकता हो। आन्तरिक मतभेदलाई संवाद र सहमतिमार्फत समाधान गर्दै संगठनलाई एकताबद्ध बनाउनु समयको माग हो। त्यसैले सबै नेता तथा कार्यकर्ताले व्यक्तिगत धारभन्दा माथि उठेर पार्टीको एकता, सुदृढीकरण र जनविश्वास पुनःस्थापनाका लागि हातेमालो गर्दै अघि बढ्न आवश्यक छ।",
    important: true,
  },
];

export async function importLegacyNotices(user) {
  if (!db) throw new Error("Firebase configuration is missing.");
  if (!adminUid || !user || user.uid !== adminUid) {
    throw new Error("कन्फिगर गरिएको प्रशासकले मात्र आयात गर्न सक्छ।");
  }

  const migrationRef = doc(db, "systemMigrations", LEGACY_MIGRATION_ID);
  const noticeRefs = LEGACY_NOTICES.map((notice) =>
    doc(db, "notices", notice.id),
  );

  return runTransaction(db, async (transaction) => {
    const migration = await transaction.get(migrationRef);
    if (migration.exists()) {
      return { imported: 0, skipped: LEGACY_NOTICES.length, alreadyDone: true };
    }

    const existing = [];
    for (const noticeRef of noticeRefs) {
      existing.push(await transaction.get(noticeRef));
    }

    let imported = 0;
    existing.forEach((snapshot, index) => {
      if (snapshot.exists()) return;
      const notice = LEGACY_NOTICES[index];
      transaction.set(noticeRefs[index], {
        title: notice.title,
        type: notice.type,
        date: notice.date,
        content: notice.content,
        important: notice.important,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        createdBy: user.uid,
        updatedBy: user.uid,
      });
      imported += 1;
    });

    transaction.set(migrationRef, {
      imported,
      skipped: LEGACY_NOTICES.length - imported,
      completedBy: user.uid,
      completedAt: serverTimestamp(),
    });

    return {
      imported,
      skipped: LEGACY_NOTICES.length - imported,
      alreadyDone: false,
    };
  });
}
